import { Component, Input } from '@angular/core';
import { NavParams } from 'ionic-angular';

/**
 * Generated class for the CoRoomTimelineDetailsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-room-timeline-details',
  templateUrl: 'co-room-timeline-details.html',
  inputs: ['roomDetails']
})
export class CoRoomTimelineDetailsComponent {
  @Input('roomDetails') room;

  constructor(public navParams: NavParams) {
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/components/co-room-timeline-details/co-room-timeline-details.ts